import styled from 'styled-components'

export const G = styled.g`
  z-index: 2;
  pointer-events: none;
`
